import { endpoints, host } from '@config/endpoints';
import request from './request';

export const getTopOccupationsBySectors = async (HubIds: string[], ISICCodes: string[],  Locations?: string[], fromQuarter?: string, toQuarter?: string, isEntryLevel?: boolean) => {
    const { path, method } = endpoints.occupationAndSector.getTopOccupationsBySectors;

    let err = null;
    let res: any = null;

    try {
        ({ data: res } = await request(
            `${host}${path}`,
            method,
            { HubIds, ISICCodes, Locations, fromQuarter, toQuarter, isEntryLevel },
            {},
        ));
    } catch (error) {
        // @ts-ignore
        err = error.message;
    }

    return [err, res];
};
